import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { siQuoteUrls } from '../../../environments/environment';
import { CheckUpdatedMaterialRequest, CheckUpdatedMaterialResponse } from '../../models/dtos';
import { BaseHttpService } from './base-http.service';

@Injectable({
  providedIn: 'root'
})
export class MaterialCheckerService {

  constructor(private readonly baseHttp: BaseHttpService) { }

  getMaterialCheckerResult(request: CheckUpdatedMaterialRequest): Observable<CheckUpdatedMaterialResponse> {
    return this.baseHttp.post<CheckUpdatedMaterialResponse>(`${siQuoteUrls.materialChecker}/GetMaterialCheckerResult`, request);
  }
}
